import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'era-master-detail',
  templateUrl: './master-detail.component.html',
  styleUrls: ['./master-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, RouterOutlet],
})
export class MasterDetailComponent {
  @Input() flexGrowLeft = 1;
  @Input() flexGrowRight = 1;

  @Input() isH2 = true;

  public hasDetail = false;

  activated() {
    this.hasDetail = true;
  }

  deactivated() {
    this.hasDetail = false;
  }
}
